<template>
  <div>
    <b-modal
      ref="purchase-order-info-modal"
      hide-footer
      :titleHtml="modalTitle"
      size="xl"
    >
      <b-skeleton-wrapper :loading="!renderComponent">
        <template #loading>
          <b-card>
            <b-row class="mb-5">
              <b-col cols="6">
                <b-row>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="6">
                <b-row>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <b-skeleton
                      animation="fade"
                      width="30%"
                      class="mb-4"
                    ></b-skeleton>
                    <b-skeleton
                      type="input"
                      animation="fade"
                      width="100%"
                      class="mb-4"
                    ></b-skeleton>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <b-skeleton
                  animation="fade"
                  width="40%"
                  class="mb-4"
                ></b-skeleton>
              </b-col>
              <b-col md="4">
                <div class="d-flex justify-content-end lable-size">
                  <b-skeleton
                    animation="fade"
                    width="50%"
                    class="mb-4"
                  ></b-skeleton>
                </div>
              </b-col>
            </b-row>
            <b-skeleton-table
              :rows="4"
              :columns="10"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </b-card>
        </template>
        <b-row class="mb-5">
          <b-col cols="6">
            <POCommonInfo
              :mainModel="mainModel"
              :parentPO="false"
              v-if="renderComponent"
            />
          </b-col>
          <!-- INFO VAT INPUT CONTROLS -->
          <b-col
            lg="3"
            md="3"
            sm="12"
            v-if="renderComponent"
          >
            <b-form-group :disabled="true">
              <label class="font-weight-bold">Hình thức thanh toán:</label>
              <b-form-select
                class="select-style"
                v-model="mainModel.importType"
                :options="listImportType"
                size="sm"
                value-field="id"
                text-field="name"
              >
              </b-form-select>
            </b-form-group>
            <b-form-group :disabled="true">
              <label
                style="margin-bottom: 0.75rem"
                class="font-weight-bold"
              >Chiết khấu:</label>
              <b-row>
                <b-col
                  class="pr-0"
                  cols="5"
                >
                  <b-form-select
                    class="select-style"
                    v-model="mainModel.discountType"
                    :options="listAmountType"
                    size="sm"
                    value-field="id"
                    text-field="name"
                  >
                  </b-form-select>
                </b-col>
                <b-col
                  class="pl-0"
                  cols="7"
                >
                  <b-form-input
                    class="input-style text-right"
                    size="sm"
                    v-model="mainModel.discountAmount"
                    placeholder="Chiết khấu"
                  ></b-form-input>
                </b-col>
              </b-row>
            </b-form-group>

            <POVat
              :editable="false"
              :mainModel="mainModel"
              v-if="renderComponent"
            />
          </b-col>
          <!-- PAYMENT INPUT CONTROLS -->
          <b-col
            lg="3"
            md="3"
            sm="12"
          >
            <POPayment
              :editable="false"
              :mainModel="mainModel"
              v-if="renderComponent"
            />
          </b-col>
        </b-row>
        <b-row v-if="renderComponent">
          <b-col md="8">
            <span class="font-weight-bolder lable-size">Danh sách sản phẩm:</span>
          </b-col>
          <b-col md="4">
            <b-checkbox
              v-model="mainModel.isVAT"
              class="d-flex justify-content-end lable-size"
              :disabled="true"
            >Đơn giá đã bao gồm VAT
            </b-checkbox>
          </b-col>
        </b-row>
        <b-table
          :fields="fieldProduct"
          :items="mainModel.details"
          hover
          bordered
          class="mt-4"
          v-if="renderComponent"
        >
          <template v-slot:cell(productName)="row">
            <span
              v-text="row.item.productCode"
              style="font-size: 12px"
              v-show="row.item.productCode"
            ></span>
            <br v-if="row.item.productCode" />
            <span
              v-text="row.item.productName"
              style="white-space: normal; color: #3699ff"
            ></span>
          </template>
        </b-table>
      </b-skeleton-wrapper>
    </b-modal>
  </div>
</template>

<script>
import { PURCHASE_ORDER_TYPE } from '../../../utils/constants';
import { formatDate, convertPrice, makeToastFaile } from '@/utils/common';
import PurchaseOrderService from '@/core/api/purchase-order/purchase-order.service';
import { PurchaseOrderModel } from '@/core/models/PurchaseOrder.model';
import POPayment from '../purchase-orders/POPayment';
import POVat from '../purchase-orders/POVat';
import POCommonInfo from '../purchase-orders/POCommonInfo';
export default {
  data() {
    return {
      modalTitle: '',
      mainModel: null,
      listAmountType: [
        {
          id: 1,
          name: 'Tiền mặt',
        },
        {
          id: 2,
          name: '%',
        },
      ],
      listImportType: PURCHASE_ORDER_TYPE,
      fieldProduct: [
        {
          key: 'productName',
          label: 'Sản phẩm',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '15%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'prevUnitPrice',
          label: 'Giá nhập gần nhất',
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? this.formatMoney(value) : 0;
          },
        },
        {
          key: 'salePowerWeek',
          label: 'Sức bán tuần',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
        },
        {
          key: 'salePowerMonth',
          label: 'Sức bán tháng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '8%' },
          tdClass: 'text-right',
        },
        {
          key: 'quantity',
          label: 'SL',
          thStyle: { fontWeight: 600, color: '#181c32', width: '7%' },
          tdClass: 'text-right',
        },
        {
          key: 'quantityApprove',
          label: 'SL đáp ứng',
          thStyle: { fontWeight: 600, color: '#181c32', width: '7%' },
          tdClass: 'text-right',
        },
        {
          key: 'unitPrice',
          label: 'Đơn giá (VAT)',
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? this.formatMoney(value) : 0;
          },
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
          thStyle: { fontWeight: 600, color: '#181c32', width: '11%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? this.formatMoney(value) : 0;
          },
        },
        {
          key: 'salePrice',
          label: 'Đơn giá bán',
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? this.formatMoney(value) : 0;
          },
        },
      ],
      renderComponent: false,
    };
  },
  methods: {
    initMainModel() {
      return {
        id: null,
        code: '',
        providerId: null,
        providerName: '',
        description: '',
        storeId: null,
        storeName: '',
        discountAmount: 0,
        discountType: 1,
        vatAmount: 0,
        vatType: 2,
        vatValue: 0,
        vatSerial: '',
        cashAmount: 0,
        cashAccountId: null,
        cashAccountCode: '',
        transferAmount: 0,
        transferAccountId: null,
        transferAccountCode: '',
        payDate: '',
        vatCode: '',
        vatDate: '',
        createdAt: '',
        createdBy: '',
        importType: 1,
        importReason: '',
        inChargeEmployeeId: null,
        inChargeEmployeeName: '',
        isVAT: true,
        details: [],
        totalAmount: 0,
      };
    },
    showModal: function (id, code) {
      this.renderComponent = false;
      this.mainModel = this.initMainModel();
      this.getInfoById(id);
      this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Thông tin PO mã: <a class='text-primary'>#${code}</a></span>
              </div>`;
      this.$refs['purchase-order-info-modal'].show();
    },
    formatMoney(number) {
      return convertPrice(number);
    },
    async getInfoById(id) {
      try {
        const { data } = await PurchaseOrderService.getById(id);
        const po = PurchaseOrderModel.fromJson(data.data);
        if (!po) {
          makeToastFaile('Không tìm thấy phiếu');
          return;
        }

        this.mainModel.id = po.id;
        this.mainModel.code = po.code || '';
        this.mainModel.description = po.description || '';
        this.mainModel.importReason = po.importReason || '';
        this.mainModel.storeName = po.store?.name || '';
        this.mainModel.storeId = po.storeId;
        this.mainModel.providerName = po.provider?.name || '';
        this.mainModel.providerId = po.providerId;
        this.mainModel.createdBy = po.createdByUser?.fullName || '';
        this.mainModel.inChargeEmployeeId = po.inChargeEmployeeId;
        this.mainModel.createdAt = formatDate(po.createdAt, 'HH:mm:ss DD/MM/YYYY');

        this.mainModel.discountType = po.discountType || 1;
        this.mainModel.discountAmount = po.discountAmount || 0;
        this.mainModel.isVAT = Boolean(po.isVAT);
        this.mainModel.vatType = po.vatType || 2;
        this.mainModel.vatValue = po.vatValue || 0;
        this.mainModel.vatAmount = po.vatAmount || 0;
        this.mainModel.vatCode = po.vatCode || '';
        this.mainModel.vatSerial = po.vatSerial || '';
        this.mainModel.vatDate = formatDate(po.vatDate, 'DD/MM/YYYY');

        this.mainModel.cashAmount = po.cashAmount || 0;
        this.mainModel.cashAccountId = po.cashAccountId || null;
        this.mainModel.cashAccountCode = po.cashAccountCode || '';
        this.mainModel.transferAmount = po.transferAmount || 0;
        this.mainModel.transferAccountId = po.transferAccountId || null;
        this.mainModel.transferAccountCode = po.transferAccountCode || '';
        this.mainModel.payDate = formatDate(po.payDate, 'DD/MM/YYYY');
        this.mainModel.importType = po.type || 1;

        // po.details đã hydrate (flat productName/productCode/productType + totalAmount).
        this.mainModel.details = po.details;
        this.mainModel.totalAmount = po.totalAmount;
        this.renderComponent = true;
      } catch (err) {
        const msg =
          err.response?.data?.message || err.message || 'Không tải được phiếu';
        makeToastFaile(msg);
      }
    },
  },
  components: {
    POPayment,
    POVat,
    POCommonInfo,
  },
};
</script>